import { PaymentMethodIdentifier } from '@platform-frontend/marketplace';

export class SelectPaymentMethod {
  static readonly type = '[ShoppingCartPayment] Select payment method';
  constructor(public paymentMethodIdentifier: PaymentMethodIdentifier) {}
}
